import { render } from "./BottomNavigation.vue?vue&type=template&id=3b8609e4&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=3b8609e4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8609e4"]])

export default __exports__